import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  FlatTree,
} from '@fluentui/react-components';

import { SubTree } from './sub-tree';
import { useFoldersTreeViewStyle } from '../style';
import { SubTreeItem } from './sub-tree-item';
import { LOADING_CELL } from '../utils';

export const FolderPathTreeView = ({
  folderPathTree,
  loadFolderPathTreeItem,
  loadMoreFolderPathTreeItem,
  i18n,
  selectedItemId,
  onItemSelected,
  logger,
  onDrop,
}) => {
  const classes = useFoldersTreeViewStyle();

  const { subFolders, subFoldersCount } = folderPathTree;

  const treeItems = useMemo(() => {
    if (subFolders && subFolders.length > 0) {
      const items = [...subFolders];
      if (subFolders.length < subFoldersCount) {
        items.push(LOADING_CELL);
      }
      return items;
    }
    return [];
  }, [subFolders, subFoldersCount]);

  const rootFolder = useMemo(() => ({
    folderId: 'ROOT',
    subFolders,
    subFoldersCount,
  }), [subFolders, subFoldersCount]);

  return (
    <FlatTree aria-label={i18n.getString(_TL_('folder-tree'))} className={classes.flatTree}>
      {
        treeItems && treeItems.map((folder, index) =>
          (
            <SubTreeItem
              folderItem={folder}
              level={1}
              setSize={subFolders.length}
              posinset={index + 1}
              key={folder.folderId || index}
              classes={classes}
              selectedItemId={selectedItemId}
              onRenderSubTree={folderItem => (
                <SubTree
                  folderItem={folderItem}
                  loadFolderPathTreeItem={loadFolderPathTreeItem}
                  loadMoreFolderPathTreeItem={loadMoreFolderPathTreeItem}
                  i18n={i18n}
                  level={1}
                  setSize={subFolders.length}
                  index={index + 1}
                  parentFolderId={folder.folderId}
                  classes={classes}
                  selectedItemId={selectedItemId}
                  onItemSelected={onItemSelected}
                  logger={logger}
                  onDrop={onDrop}
                />
              )}
              onLeafTreeItemClicked={(e) => {
                e.stopPropagation();
                onItemSelected(folder);
              }}
              loadMoreFolderPathTreeItem={loadMoreFolderPathTreeItem}
              parentFolder={rootFolder}
              onDrop={() => { onDrop(folder); }}
            />
          ))
      }
    </FlatTree>
  );
};

FolderPathTreeView.propTypes = {
  folderPathTree: PropTypes.shape({
    subFolders: PropTypes.arrayOf(PropTypes.shape({})),
    subFoldersCount: PropTypes.number,
  }),
  loadFolderPathTreeItem: PropTypes.func.isRequired,
  loadMoreFolderPathTreeItem: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onItemSelected: PropTypes.func.isRequired,
  selectedItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  logger: PropTypes.shape({}).isRequired,
  onDrop: PropTypes.func.isRequired,
};

FolderPathTreeView.defaultProps = {
  folderPathTree: {},
  selectedItemId: '',
};
